'use client';

import { __extends } from '../_virtual/_tslib.js';
import React__default from 'react';
import ReactDOM from 'react-dom';
import { PopupOverlay, NewPopup, Introduction, MinimumPopup } from './PopupNewUser.css.js';
import PopupService from './PopupService.js';
import vi from './vi.js';

var hasLocalStorage = !!(typeof window !== 'undefined' && window.localStorage);
if (typeof window !== 'undefined') {
    window.opera = window.opera || {};
    window._gaq = window._gaq || [];
}
var ETypePopup;
(function (ETypePopup) {
    ETypePopup["New"] = "new";
    ETypePopup["Return"] = "return";
    ETypePopup["Minimum"] = "minimum";
})(ETypePopup || (ETypePopup = {}));
var PopupNewUser = /** @class */ (function (_super) {
    __extends(PopupNewUser, _super);
    function PopupNewUser(props) {
        var _this = _super.call(this, props) || this;
        _this.isSafariBrowser = function () {
            if (typeof navigator !== 'undefined' && typeof window !== 'undefined') {
                return !!navigator.userAgent.match(/Version\/[\d.]+.*Safari/);
            }
            return false;
        };
        _this.getLinkDownload = function () {
            if (typeof window !== 'undefined') {
                window.location.href = "https://vietnamworks.onelink.me/UtAm?pid=mobile&url=".concat(encodeURIComponent(window.location.pathname));
            }
        };
        _this.pushGA = function (bannerType) {
            if (typeof window !== 'undefined') {
                if (window._gaq && window._gaq.push) {
                    window._gaq.push(['_trackEvent', 'NoThanksBanner', 'Click', bannerType]);
                }
            }
        };
        _this.initPopup = function () {
            if (hasLocalStorage) {
                var popupLocals = localStorage.getItem('popupNewUser');
                if (!popupLocals) {
                    PopupService.initializePopup();
                    _this.setState({ isShowNewPopup: true });
                }
                else {
                    popupLocals = JSON.parse(popupLocals);
                    // check User Click close btn in the last 30 days or not
                    /**
                     * VNW-20838 [Responsive] Always show banner app install if VNW app is not installed
                     *
                     * Changed timestamps 30 days to 1 day
                     *
                     * @author Thien Tran
                     * @since Mar 08, 2023
                     */
                    var timestamps1Day_1 = new Date();
                    timestamps1Day_1.setDate(timestamps1Day_1.getDate() - 1);
                    var isClick3Times = popupLocals.length >= 3;
                    if (isClick3Times) {
                        var isClicksTooOld = !!popupLocals.every(function (item) { return timestamps1Day_1.getTime() > item; });
                        if (isClicksTooOld) {
                            PopupService.initializePopup();
                            _this.setState({ isShowReturnPopup: true });
                        }
                    }
                    else {
                        _this.setState({ isShowReturnPopup: true });
                    }
                }
            }
        };
        _this.handleClickoverlay = function () {
            _this.setState({
                isShowNewPopup: false,
                isShowReturnPopup: true
            });
        };
        _this.renderPopupOverlay = function () {
            var bodyNode = typeof document !== 'undefined' && document.querySelector('body');
            if (bodyNode) {
                return ReactDOM.createPortal(React__default.createElement(PopupOverlay, { onClick: _this.handleClickoverlay, active: _this.state.isShowNewPopup }), bodyNode);
            }
            return null;
        };
        _this.handleClosePopup = function (position) {
            var onClosePopup = _this.props.onClosePopup;
            switch (position) {
                case ETypePopup.New:
                    _this.setState({ isShowNewPopup: false });
                    _this.pushGA('NEW_USER_BANNER');
                    break;
                case ETypePopup.Minimum:
                    PopupService.setWhenUserClose();
                    _this.setState({ isShowMinimumPopup: false });
                    _this.pushGA('MINIMUM_USER_BANNER');
                    break;
                case ETypePopup.Return:
                    PopupService.setWhenUserClose();
                    _this.setState({ isShowReturnPopup: false });
                    _this.pushGA('RETURN_USER_BANNER');
                    break;
            }
            onClosePopup && onClosePopup();
        };
        _this.renderStarIcon = function () {
            var ratingStartList = [];
            for (var i = 0; i < 5; i++) {
                ratingStartList.push(React__default.createElement("svg", { className: 'rating', width: '14px', height: '13px', viewBox: '0 0 14 13', version: '1.1', xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink', key: i },
                    React__default.createElement("g", { id: 'Popup-Install-App', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
                        React__default.createElement("g", { id: 'New-User', transform: 'translate(-115.000000, -557.000000)', fill: '#ff7d55', fillRule: 'nonzero' },
                            React__default.createElement("g", { id: 'Group-4', transform: 'translate(0.000000, 387.000000)' },
                                React__default.createElement("g", { id: 'Group-3', transform: 'translate(16.000000, 103.000000)' },
                                    React__default.createElement("path", { d: 'M102.349306,79.533297 L105.577822,77.1675744 L108.801699,79.533297 C109.135683,79.774508 109.404726,79.8255334 109.627382,79.6631798 C109.840761,79.5008263 109.891787,79.2317834 109.757265,78.8421349 L108.490908,75.0477013 L111.742617,72.7098107 C112.076601,72.4732384 112.201845,72.2273888 112.118349,71.9676232 C112.034853,71.7171349 111.789003,71.5826134 111.376162,71.5872521 L107.382265,71.6104455 L106.166933,67.8020959 C106.03705,67.4078087 105.846865,67.2129845 105.577822,67.2129845 C105.30414,67.2129845 105.113955,67.4078087 104.988711,67.8020959 L103.76874,71.6104455 L99.7748433,71.5872521 C99.3620015,71.5826134 99.1207906,71.7171349 99.0372945,71.9676232 C98.9491597,72.2273888 99.0790425,72.4732384 99.4083882,72.7098107 L102.660097,75.0477013 L101.39374,78.8421349 C101.263857,79.2317834 101.314882,79.5008263 101.528261,79.6631798 C101.746279,79.8255334 102.019961,79.774508 102.349306,79.533297 Z', id: 'icon-star-l' })))))));
            }
            return ratingStartList;
        };
        _this.renderCloseBtn = function (position) {
            return (React__default.createElement("svg", { className: 'filter-close', viewBox: '0 0 50 50', onClick: function () { return _this.handleClosePopup(position); } },
                React__default.createElement("path", { d: 'M 14.40625 13 L 13 14.40625 L 23.625 25 L 13 35.59375 L 14.40625 37 L 25.0625 26.40625 L 35.6875 37 L 37.09375 35.59375 L 26.46875 25 L 37.09375 14.40625 L 35.6875 13 L 25.0625 23.59375 Z' })));
        };
        _this.renderVietnamworksLogo = function () {
            return (React__default.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: '68', height: '68' },
                React__default.createElement("defs", null,
                    React__default.createElement("clipPath", { id: 'a' },
                        React__default.createElement("path", { d: 'M62 0a6 6 0 0 1 6 6v56a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6h56Z' })),
                    React__default.createElement("clipPath", { id: 'b' },
                        React__default.createElement("path", { d: 'M29.401 6.242c.227.407-.168.87-.675.787l-.515-.084c-3.37-.478-7.263.643-7.626.75l-.027.009c-4.626 1.297-8.872.908-8.872.908-3.35-.137-6.803-1.157-6.803-1.157C2.703 6.87 0 6.765 0 6.765S5.784 1.682 14.411.25c0 0 10.476-2.12 14.99 5.992Z' })),
                    React__default.createElement("clipPath", { id: 'd' },
                        React__default.createElement("path", { d: 'm25.997 10.596.003.114v.198c-.025 1.627-.593 9.355-8.885 16.66 0 0-7.869 7.308-16.649 7.094-.487-.012-.644-.634-.22-.864 2.326-1.257 6.957-4.468 11.855-11.866 0 0 7.772-10.601 2.98-21.93h.015l.02-.001h.211c1.595.025 10.379.618 10.67 10.595Z' })),
                    React__default.createElement("clipPath", { id: 'f' },
                        React__default.createElement("path", { d: 'm25.965 16.763-.06.04c-1.179.777-13.186 8.356-21.906.37 0 0-.026-.023-.073-.07l-.067-.066C2.938 16.107-2.123 10.42 1.013.43A.604.604 0 0 1 2.14.35c1.436 3.02 5.387 10.2 11.758 13.464 0 0 4.435 2.91 11.703 2.927l.398-.003a.577.577 0 0 1-.034.024Z' })),
                    React__default.createElement("clipPath", { id: 'h' },
                        React__default.createElement("path", { d: 'M13.465.147c.426.055.551.597.19.823-2.557 1.596-8.847 6.589-11.179 18.097 0 0-5.303-8.239-.388-15.087 0 0 3.286-4.878 11.377-3.833Z' })),
                    React__default.createElement("linearGradient", { id: 'c', x1: '-.001', y1: '4.333', x2: '29.466', y2: '4.333', gradientUnits: 'userSpaceOnUse' },
                        React__default.createElement("stop", { stopColor: '#3baaff', offset: '0%' }),
                        React__default.createElement("stop", { stopColor: '#47b2ff', offset: '24%' }),
                        React__default.createElement("stop", { stopColor: '#67c9ff', offset: '68%' }),
                        React__default.createElement("stop", { stopColor: '#82dcff', offset: '100%' })),
                    React__default.createElement("linearGradient", { id: 'e', x1: '22.651', y1: '8.871', x2: '-3.642', y2: '28.797', gradientUnits: 'userSpaceOnUse' },
                        React__default.createElement("stop", { stopColor: '#0059ff', offset: '10%' }),
                        React__default.createElement("stop", { stopColor: '#035eff', offset: '13%' }),
                        React__default.createElement("stop", { stopColor: '#2187ff', offset: '50%' }),
                        React__default.createElement("stop", { stopColor: '#34a0ff', offset: '79%' }),
                        React__default.createElement("stop", { stopColor: '#3baaff', offset: '96%' })),
                    React__default.createElement("linearGradient", { id: 'g', x1: '-1.609', y1: '10.4', x2: '17.891', y2: '10.4', gradientUnits: 'userSpaceOnUse' },
                        React__default.createElement("stop", { stopColor: '#82dcff', offset: '0%' }),
                        React__default.createElement("stop", { stopColor: '#65c7ff', offset: '25%' }),
                        React__default.createElement("stop", { stopColor: '#47b2ff', offset: '57%' }),
                        React__default.createElement("stop", { stopColor: '#3baaff', offset: '75%' })),
                    React__default.createElement("linearGradient", { id: 'i', x1: '-2.266', y1: '13.235', x2: '14.73', y2: '4.889', gradientUnits: 'userSpaceOnUse' },
                        React__default.createElement("stop", { stopColor: '#0059ff', offset: '0%' }),
                        React__default.createElement("stop", { stopColor: '#1271ff', offset: '26%' }),
                        React__default.createElement("stop", { stopColor: '#309aff', offset: '75%' }),
                        React__default.createElement("stop", { stopColor: '#3baaff', offset: '100%' }))),
                React__default.createElement("g", { clipPath: 'url(#a)' },
                    React__default.createElement("path", { fill: '#001644', d: 'M0 0h68v68H0V0z' })),
                React__default.createElement("g", { clipPath: 'url(#b)', transform: 'translate(20.133 10)' },
                    React__default.createElement("path", { fill: 'url(#c)', d: 'M0 0h29.467v8.667H0V0z' })),
                React__default.createElement("g", { clipPath: 'url(#d)', transform: 'translate(34 16.933)' },
                    React__default.createElement("path", { fill: 'url(#e)', d: 'M0 0h26v34.667H0V0z' })),
                React__default.createElement("g", { clipPath: 'url(#f)', transform: 'translate(8 37.733)' },
                    React__default.createElement("path", { fill: 'url(#g)', d: 'M0 0h26v20.8H0V0z' })),
                React__default.createElement("g", { clipPath: 'url(#h)', transform: 'translate(8 18.667)' },
                    React__default.createElement("path", { fill: 'url(#i)', d: 'M0 0h13.867v19.067H0V0z' }))));
        };
        _this.renderNewPopup = function () {
            var langCode = _this.props.langCode;
            var closeBtn = _this.renderCloseBtn(ETypePopup.New);
            var logo = _this.renderVietnamworksLogo();
            var ratingStart = _this.renderStarIcon();
            var bodyNode = typeof document !== 'undefined' && document.querySelector('body');
            if (bodyNode) {
                return ReactDOM.createPortal(React__default.createElement(NewPopup, null,
                    closeBtn,
                    React__default.createElement("div", { className: 'title' }, langCode === 'en'
                        ? "Experience VietnamWorks - Vietnam's largest job search application"
                        : vi["Experience VietnamWorks - Vietnam's largest job search application"]),
                    React__default.createElement(Introduction, null,
                        logo,
                        React__default.createElement("div", { className: 'content' },
                            React__default.createElement("div", { className: 'app-title' }, "VietnamWorks"),
                            React__default.createElement("div", { className: 'app-brief' }, langCode === 'en' ? 'Job Search and Recruitment' : vi['Job Search and Recruitment']),
                            React__default.createElement("div", { className: 'app-rating' },
                                ratingStart,
                                React__default.createElement("span", { className: 'app-score' }, "(4,7)"),
                                ' '))),
                    React__default.createElement("button", { onClick: _this.getLinkDownload, className: 'download-btn' }, langCode === 'en' ? 'Install Application' : vi['Install Application'])), bodyNode);
            }
            return null;
        };
        _this.renderMinimumPopup = function () {
            var langCode = _this.props.langCode;
            var closeBtn = _this.renderCloseBtn(ETypePopup.Minimum);
            var logo = _this.renderVietnamworksLogo();
            var ratingStart = _this.renderStarIcon();
            return (React__default.createElement(MinimumPopup, null,
                closeBtn,
                React__default.createElement("div", { className: 'wrap-content-minimum' },
                    logo,
                    React__default.createElement("div", { className: 'content-popup' },
                        React__default.createElement("div", { className: 'app-title' }, "VietnamWorks"),
                        React__default.createElement("div", { className: 'app-brief' }, langCode === 'en' ? 'Job Search and Recruitment' : vi['Job Search and Recruitment']),
                        React__default.createElement("div", { className: 'app-rating' },
                            ratingStart,
                            React__default.createElement("span", { className: 'app-score' }, "(4,7)"),
                            ' ')),
                    React__default.createElement("button", { onClick: _this.getLinkDownload, className: 'download-btn' }, langCode === 'en' ? 'Open App' : vi['Open App']))));
        };
        _this.checkIsMobile = function () {
            if (typeof window !== 'undefined') {
                _this.setState({ isMobile: window.innerWidth < 900 });
            }
        };
        _this.state = {
            isMobile: false,
            isShowNewPopup: false,
            isShowMinimumPopup: false,
            isShowReturnPopup: false
        };
        return _this;
    }
    PopupNewUser.prototype.componentDidMount = function () {
        if (typeof window !== 'undefined') {
            window.addEventListener('resize', this.checkIsMobile);
        }
        this.checkIsMobile();
        this.initPopup();
    };
    PopupNewUser.prototype.componentWillUnmount = function () {
        if (typeof window !== 'undefined') {
            window.removeEventListener('resize', this.checkIsMobile);
        }
    };
    PopupNewUser.prototype.render = function () {
        var _a = this.state, isMobile = _a.isMobile, isShowNewPopup = _a.isShowNewPopup, isShowReturnPopup = _a.isShowReturnPopup, isShowMinimumPopup = _a.isShowMinimumPopup;
        if (!isMobile || isShowReturnPopup) {
            return null;
        }
        var newPopup = this.renderNewPopup();
        var minimumPopup = this.renderMinimumPopup();
        var overlay = this.renderPopupOverlay();
        return (React__default.createElement(React__default.Fragment, null,
            isShowNewPopup ? newPopup : null,
            isShowNewPopup ? overlay : null,
            isShowMinimumPopup ? minimumPopup : null));
    };
    return PopupNewUser;
}(React__default.PureComponent));

export { PopupNewUser as default };
//# sourceMappingURL=index.js.map
